import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Card from 'components/Card';
import Steps from '../../../components/Steps';

import './style.scss';

interface PasswordProps {
    type: 'modifyPassword' | 'upgradePassword';
}

const pageTitles: Record<PasswordProps['type'], string> = {
    modifyPassword: __('登录密码修改'),
    upgradePassword: __('更新登录密码')
};

const Password: React.FC<PasswordProps> = ({ type }) => {
    const location = useLocation();

    return (
        <Card form>
            <h2>{pageTitles[type]}</h2>
            <div className="modify-password-root">
                {!location.pathname.includes('tips') && <Steps type={type} />}
                <Outlet context={type} />
            </div>
        </Card>
    );
};

export default Password;
